export const getFieldError = (name, form) => {
  return form.touched[name] || form.submitCount > 0 ? form.getFieldMeta(name).error : '';
};
